/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Users_Template_CountInputs */

const en_tables_users_template_count = /** @type {(inputs: Tables_Users_Template_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template Count`)
};

const de_tables_users_template_count = /** @type {(inputs: Tables_Users_Template_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Templates`)
};

/**
* | output |
* | --- |
* | "Template Count" |
*
* @param {Tables_Users_Template_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_users_template_count = /** @type {((inputs?: Tables_Users_Template_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Users_Template_CountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_users_template_count(inputs)
	return de_tables_users_template_count(inputs)
});